import { atom } from 'recoil';
import { CollectionHopeDateType } from '@/mobile/types/api/mypage/collectionHopeDate';

// 集荷希望日時は未選択を空文字で持ち、確認画面遷移前の必須チェックをしやすくする。
const collectionHopeDateState = atom<CollectionHopeDateType>({
  key: 'collectionHopeDateState',
  default: {
    // 集荷希望日
    collectionHopeDate: '',
    // 集荷希望時間帯
    collectionHopeTimezone: '',
  },
});

export default collectionHopeDateState;
